import { Box, Paper, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import CustomRangePicker from "../../../components/DateRangePicker";
import appcolors from "../../../constants/Colors";
import SupplierLineChart from "./SupplierLineChart";
import moment from "moment";
import GlobalButton from "../../../components/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import { t } from "i18next";

function MainChart({
  dailyReport,
  isLoading,
  handleFilterDate,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) {
  return (
    <Paper sx={{ borderRadius: 1, p: 2 }}>
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Stack>
          <Typography
            variant="h1"
            fontSize={"1rem"}
            fontWeight={600}
            textTransform={"capitalize"}
          >
            {t("weeklyEarningRecord")}
          </Typography>
          {/* <Typography variant="body2" color={appcolors.crayolaGrey}>
            Last 7 Days{moment().format("DD/MM/YYYY")}
          </Typography>
          <Typography variant="h1" fontSize={"1rem"} fontWeight={600}>
            USA 100
          </Typography> */}
          {/* <Typography
            variant="body2"
            fontSize={"0.75rem"}
            color={appcolors.crayolaGrey}
          >
            product sale :{" "}
            <span
              style={{
                fontSize: "0.875rem",
                fontWeight: "bold",
                color: appcolors.black,
              }}
            >
              6
            </span>
          </Typography> */}
          {/* <Typography
            variant="body2"
            fontSize={"0.75rem"}
            color={appcolors.crayolaGrey}
          >
            profit value:{" "}
            <span
              style={{
                fontSize: "0.875rem",
                fontWeight: "bold",
                color: appcolors.black,
              }}
            >
              USD 259.00
            </span>
          </Typography> */}
        </Stack>
        <Stack direction={"row"} alignItems={"center"}>
          <CustomRangePicker
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            stackProps={{
              borderRadius: "6px 0px 0px 6px",
              border: "1px solid #dddddd",
            }}
          />
          <GlobalButton
            endIcon={<SearchIcon />}
            handleClickBtn={() => handleFilterDate(startDate, endDate)}
            styleProps={{
              color: "primary",
              width: "auto",
              borderRadius: "0px 6px 6px 0px",
              minWidth: 45,
              height: "42px",
              "& .MuiButton-icon": {
                marginLeft: "0px",
              },
            }}
          />
        </Stack>
      </Stack>
      <Box>
        {dailyReport?.length > 0 ? (
          <SupplierLineChart chartData={dailyReport} />
        ) : isLoading === false && dailyReport?.length === 0 ? (
          <Stack
            height={"100%"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Typography variant="h5" fontWeight={600}>
              {t("noDataFound")}!
            </Typography>
          </Stack>
        ) : null}
      </Box>
    </Paper>
  );
}

export default MainChart;
